var PageWidget2Ctrl = function ($scope,
                                $sce,
                                $timeout,
                                OfficeDA,
                                UserSession,
                                office,
                                settings,
                                gettextCatalog,
                                Notification) {
    var self = this;

    this._sce = $sce;
    this.showPremiumNotification = !['plus', 'enterprise'].includes($scope.subscription.package);
    this.office = office;
    this._settings = settings;
    this.widgetHtmlCode = '';
    this._OfficeDA = OfficeDA;
    this._Notification = Notification;
    this.gettextCatalog = gettextCatalog;
    this._init();
    this.user = UserSession.get();
    this.iframeVisible = true;
    this.stringDefaults = {
        'de-de': {
            'locations.stepLabel': 'Standorte',
            'services.stepLabel': 'Leistungen',
            'timeSlot.stepLabel': 'Termin',
            'timeSlot.skip': 'Bei dieser Leistung kann nur eine Kontaktanfrage gestellt werden. Eine Terminauswahl ist nicht möglich.',
            'timeSlot.nextFree': 'Nächster freier Termin',
            'timeSlot.noFreeSlot': 'Leider sind derzeit alle möglichen Termine ausgebucht. Versuchen Sie es daher zu einem späteren Zeitpunkt noch einmal.',
            'employees.stepLabel': 'Mitarbeiterauswahl',
            'employees.unspecific': 'kein bestimmter Mitarbeiter',
            'contact.stepLabel': 'Kontaktdaten und Zusammenfassung',
            'payment.stepLabel': 'Online-Zahlung',
            'success.stepLabel': 'Abschluss der Buchung',
            'success.stepLabelContact': 'Abschluss der Anfrage',
            'success.congratulations': 'Ihre Terminanfrage wurde erfolgreich übermittelt. Eine Terminbestätigung erhalten Sie per E-Mail. Bitte prüfen Sie auch Ihren Spam-Ordner!',
            'success.congratulationsRequest': 'Ihre Kontaktanfrage wurde erfolgreich übermittelt.',
        },
        'de-ch': {
            'locations.stepLabel': 'Standorte',
            'services.stepLabel': 'Leistungen',
            'timeSlot.stepLabel': 'Termin',
            'timeSlot.skip': 'Bei dieser Leistung kann nur eine Kontaktanfrage gestellt werden. Eine Terminauswahl ist nicht möglich.',
            'timeSlot.nextFree': 'Nächster freier Termin',
            'timeSlot.noFreeSlot': 'Leider sind derzeit alle möglichen Termine ausgebucht. Versuchen Sie es daher zu einem späteren Zeitpunkt noch einmal.',
            'employees.stepLabel': 'Mitarbeiterauswahl',
            'employees.unspecific': 'kein bestimmter Mitarbeiter',
            'contact.stepLabel': 'Kontaktdaten und Zusammenfassung',
            'payment.stepLabel': 'Online-Zahlung',
            'success.stepLabel': 'Abschluss der Buchung',
            'success.stepLabelContact': 'Abschluss der Anfrage',
            'success.congratulations': 'Ihre Terminanfrage wurde erfolgreich übermittelt. Eine Terminbestätigung erhalten Sie per E-Mail. Bitte prüfen Sie auch Ihren Spam-Ordner!',
            'success.congratulationsRequest': 'Ihre Kontaktanfrage wurde erfolgreich übermittelt.',
        },
        'en': {
            'locations.stepLabel': 'Locations',
            'services.stepLabel': 'Services',
            'timeSlot.stepLabel': 'Appointment',
            'timeSlot.skip': 'With this service, only a contact request can be made. It is not possible to select an appointment.',
            'timeSlot.nextFree': 'Next free appointment',
            'timeSlot.noFreeSlot': 'Unfortunately, all available dates are currently fully booked. Please try again at a later date.',
            'employees.stepLabel': 'Employee selection',
            'employees.unspecific': 'No specific employee',
            'contact.stepLabel': 'Contact details and summary',
            'payment.stepLabel': 'Online payment',
            'success.stepLabel': 'Completion of the booking',
            'success.stepLabelContact': 'Completion of the request',
            'success.congratulations': 'Your appointment request has been successfully submitted. You will receive an appointment confirmation by e-mail. Please also check your spam folder!',
            'success.congratulationsRequest': 'Your contact request has been successfully submitted',
        },
        'fr': {
            'locations.stepLabel': 'Sites',
            'services.stepLabel': 'Services',
            'timeSlot.stepLabel': 'Rendez-vous',
            'timeSlot.skip': 'Avec ce service, seule une demande de contact peut être effectuée. Il n\'est pas possible de sélectionner un rendez-vous.',
            'timeSlot.nextFree': 'Prochain rendez-vous disponible',
            'timeSlot.noFreeSlot': 'Malheureusement, toutes les dates disponibles sont actuellement complètes. Veuillez réessayer ultérieurement.',
            'employees.stepLabel': 'Sélection des employés',
            'employees.unspecific': 'Aucun employé en particulier',
            'contact.stepLabel': 'Coordonnées et résumé',
            'payment.stepLabel': 'Paiement en ligne',
            'success.stepLabel': 'Finalisation de la réservation',
            'success.stepLabelContact': 'Exécution de la demande',
            'success.congratulations': 'Votre demande de rendez-vous a été envoyée avec succès. Vous recevrez une confirmation de rendez-vous par e-mail. Veuillez également vérifier votre dossier spam !',
            'success.congratulationsRequest': 'Votre demande de contact a été envoyée avec succès.',
        },
        'it': {
            'locations.stepLabel': 'Località',
            'services.stepLabel': 'Servizi',
            'timeSlot.stepLabel': 'Appuntamento',
            'timeSlot.skip': 'Con questo servizio è possibile solo inviare una richiesta di contatto. Non è possibile selezionare un appuntamento.',
            'timeSlot.nextFree': 'Prossimo appuntamento gratuito',
            'timeSlot.noFreeSlot': 'Purtroppo tutte le date disponibili sono al momento al completo. Riprova più tardi.',
            'employees.stepLabel': 'Selezione dei dipendenti',
            'employees.unspecific': 'Nessun dipendente specifico',
            'contact.stepLabel': 'Dettagli di contatto e sintesi',
            'payment.stepLabel': 'Pagamento online',
            'success.stepLabel': 'Completamento della prenotazione',
            'success.stepLabelContact': 'Completamento della richiesta',
            'success.congratulations': 'La tua richiesta di appuntamento è stata inviata con successo. Riceverai una conferma dell\'appuntamento via e-mail. Controlla anche la cartella dello spam!',
            'success.congratulationsRequest': 'La tua richiesta di contatto è stata inviata con successo.',
        },
        'lu': {
            'locations.stepLabel': 'Standuerter',
            'services.stepLabel': 'Services',
            'timeSlot.stepLabel': 'Rendez-vous',
            'timeSlot.skip': 'Mat dësem Service kann een nëmmen eng Kontaktufro maachen. Et ass net méiglech, en Rendez-vous auszewielen.',
            'timeSlot.nextFree': 'Nächst gratis Rendez-vous',
            'timeSlot.noFreeSlot': 'Leider sinn all disponibel Datumen de Moment komplett ausgebucht. Probéiert et w.e.g. méi spéit nach eng Kéier.',
            'employees.stepLabel': 'Auswiel vun de Mataarbechter',
            'employees.unspecific': 'Metacharacter',
            'contact.stepLabel': 'Kontaktdetailer a Kuerzopstellung',
            'payment.stepLabel': 'Online-Bezuelung',
            'success.stepLabel': 'Ofschloss vun der Buchung',
            'success.stepLabelContact': 'Ofschloss vun der Ufro',
            'success.congratulations': 'Äre Rendez-vous-Ufro gouf erfollegräich ofgeschéckt. Dir kritt eng Rendez-vous-Bestätegung per E-Mail. Kuckt w.e.g. och an Ärem Spam-Ordner no!',
            'success.congratulationsRequest': 'Äre Kontaktufro gouf erfollegräich ofgeschéckt.',
        }
    };
    this.languageOrder = ['de-de', 'de-ch', 'en', 'fr', 'it', 'lu'];
    this.stringOrder = Object.keys(this.stringDefaults['de-de']);
    this.bookingUrl = this.office.profile.booking2Url;

    $scope.$watch(function () {
        return office.settings.widget.appointment.autoHeight;
    }, this.generateWidgetCode.bind(self), true);
};

PageWidget2Ctrl.prototype.getEncodedUrl = function (url) {
    return encodeURIComponent(url);
};

PageWidget2Ctrl.prototype._init = function () {
    if (!this.office.settings.widget || !this.office.settings.widget.appointment || !this.office.settings.widget.appointment.primary || !this.office.settings.widget.appointment.primaryContrast) {
        this.revert();
    }
};

PageWidget2Ctrl.prototype.generateWidgetCode = function () {
    var widgetCode = '';

    if (this.office.settings.widget.appointment.autoHeight) {
        widgetCode += "<iframe src=\"" + this.bookingUrl + "\" frameBorder=\"0\" height=\"600px\" width=\"100%\" scrolling=\"yes\" id=\"t2g-booking\" allowpaymentrequest></iframe><script>var bookingFrame = document.getElementById('t2g-booking');var receiveMessage = function (event) { if (event.origin === '" + this._settings.urls.booking2 + "') { if (bookingFrame && event.data.type === 'heightChanged') { bookingFrame.height = event.data.height + 120; }}}; window.addEventListener('message', receiveMessage, false);</script>";
    } else {
        widgetCode += `<iframe src="${this.bookingUrl}" frameBorder="0" height="600px" width="100%" scrolling="yes" id="t2g-booking" allowpaymentrequest></iframe>`;
    }

    this.widgetHtmlCode = this._sce.trustAsHtml(widgetCode);
};

PageWidget2Ctrl.prototype.save = function () {
    var self = this;

    this.iframeVisible = false;
    this._OfficeDA
        .update(this.office)
        .then(() => {
            self._Notification.addSuccessMessage(self.gettextCatalog.getString('Widget settings saved'));
        })
        .catch((error) => {
            self._Notification.addErrorMessage({text: error});
        })
        .finally(() => {
            self.iframeVisible = true;
        });
};

PageWidget2Ctrl.prototype.revert = function () {
    this.office.settings.widget2.colors = {
        p: '#91BD55',
        background: '#ffffff',
        dayBackground: '#eaf2df'
    };
    this.save();
};

module.exports = PageWidget2Ctrl;
